let initPrevState:any = {
    artists: null,
    compositions: null
};

export const CHANGE_COUNTS = "CHANGE_COUNTS";

export function counts (prevState:any = initPrevState, action:any){
    if (action.type == CHANGE_COUNTS){
        return {
            ...action.payload
        };
    }

    return prevState;
}